var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-box"},[_c('h1',{staticClass:"testTitle"},[_vm._v("仙尊大人，恭喜您測試成功")]),_c('p',{staticClass:"ma dl"},[_vm._v(" 您的神劍禮品碼為： "),_c('input',{staticClass:"inputbox",attrs:{"type":"text"},domProps:{"value":_vm.testMa}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }